(function attach(root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(root);
  else {
    const api = root.SB15ExpressCheckout || factory(root);
    root.SB15ExpressCheckout = api;
    api.boot();
  }
})(typeof window === 'undefined' ? globalThis : window, function factory(root) {
  const BUTTON_SELECTOR = '[data-sb15-express-checkout]';
  const bootStates = new WeakMap();

  function getFormState(button, documentRef) {
    const form = documentRef.getElementById(button.dataset.formId);
    const variant = form?.querySelector('.product-variant-id');
    const nativeSubmit = form?.querySelector('[type="submit"][name="add"]');
    const available = Boolean(
      form
      && variant?.value
      && !variant.disabled
      && nativeSubmit
      && !nativeSubmit.disabled
      && nativeSubmit.getAttribute?.('aria-disabled') !== 'true'
      && button.dataset.sb15VariantPending !== 'true'
    );

    return { available, form, nativeSubmit, variant };
  }

  function createExpressCheckout({ fetchImpl, navigate, documentRef, FormDataRef }) {
    const inFlight = new WeakSet();

    function syncButtonState(button) {
      const { available } = getFormState(button, documentRef);
      const enabled = available && !inFlight.has(button);
      button.disabled = !enabled;
      return enabled;
    }

    function setVariantPending(button, pending) {
      if (pending) button.dataset.sb15VariantPending = 'true';
      else delete button.dataset.sb15VariantPending;
      syncButtonState(button);
    }

    async function submit(button) {
      if (inFlight.has(button)) return false;

      const { available, form, variant } = getFormState(button, documentRef);
      if (!available) {
        syncButtonState(button);
        return false;
      }

      const wrapper = form.closest('product-form');
      const errorWrapper = wrapper?.querySelector('.product-form__error-message-wrapper');
      const errorMessage = wrapper?.querySelector('.product-form__error-message');
      inFlight.add(button);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (errorWrapper) errorWrapper.hidden = true;

      try {
        const body = new FormDataRef();
        body.append('id', variant.value);
        body.append('quantity', '1');
        const formId = form.getAttribute('id');
                const sp = documentRef.querySelector(`[name="selling_plan"][form="${formId}"]:checked`);
                        if (sp && sp.value) body.append('selling_plan', sp.value);
        const response = await fetchImpl(button.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || 'No hemos podido iniciar la compra exprés.');
        }

        navigate(button.dataset.checkoutUrl);
        return true;
      } catch (error) {
        if (errorMessage) {
          errorMessage.textContent = error.message || 'No hemos podido iniciar la compra exprés.';
        }
        if (errorWrapper) errorWrapper.hidden = false;
        return false;
      } finally {
        inFlight.delete(button);
        button.removeAttribute('aria-busy');
        syncButtonState(button);
      }
    }

    submit.setVariantPending = setVariantPending;
    submit.syncButtonState = syncButtonState;
    return submit;
  }

  function getGlobalSubscribe() {
    if (typeof subscribe === 'function') return subscribe;
    return root.subscribe;
  }

  function getGlobalEvents() {
    if (typeof PUB_SUB_EVENTS !== 'undefined') return PUB_SUB_EVENTS;
    return root.PUB_SUB_EVENTS;
  }

  function boot(options = {}) {
    const documentRef = options.documentRef || root.document;
    if (!documentRef) return;

    let state = bootStates.get(documentRef);
    if (!state) {
      const submit = createExpressCheckout({
        fetchImpl: options.fetchImpl || root.fetch?.bind(root),
        navigate: options.navigate || root.location?.assign.bind(root.location),
        documentRef,
        FormDataRef: options.FormDataRef || root.FormData,
      });
      const allButtons = () => [...documentRef.querySelectorAll(BUTTON_SELECTOR)];
      const subscribeImpl = options.subscribeImpl || getGlobalSubscribe();
      const events = options.events || getGlobalEvents();

      if (typeof subscribeImpl === 'function' && events) {
        subscribeImpl(events.optionValueSelectionChange, () => {
          allButtons().forEach((button) => submit.setVariantPending(button, true));
        });
        subscribeImpl(events.variantChange, () => {
          allButtons().forEach((button) => submit.setVariantPending(button, false));
        });
      }

      state = { submit };
      bootStates.set(documentRef, state);
    }

    documentRef.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      if (button.dataset.sb15ExpressBound === 'true') return;
      button.dataset.sb15ExpressBound = 'true';
      button.addEventListener('click', () => state.submit(button));
      state.submit.syncButtonState(button);
    });
  }

  if (root.document?.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', boot, { once: true });
  }

  return { boot, createExpressCheckout };
});
